import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'underscore';

const ConceptSelector = ({ concepts, conceptsFeedback, onlyShowConceptsWithConceptFeedback, currentConceptUID, selectorDisabled, handleSelectorChange, id, }) => {
  const conceptsToOptions = () => {
    let options = concepts.data["0"];
    if(onlyShowConceptsWithConceptFeedback) {
      const feedbackKeys = conceptsFeedback?.data ? _.keys(conceptsFeedback.data) : [];
      options = _.filter(options, (concept) => {
        return feedbackKeys.includes(concept.uid);
      });
    }
    return _.map(options, (concept)=>{
      return (
        {label: concept.displayName, value: concept.uid, shortenedName: concept.name}
      )
    })
  }

  const currentConcept = () => {
    return _.find(concepts.data["0"], {uid: currentConceptUID})
  }

  const currentValue = () => {
    const concept = currentConcept()
    if (currentConceptUID && currentConceptUID.length > 0 && concept) {
      return {
        label: concept.displayName,
        value: concept.uid,
        shortenedName: concept.name
      }
    }
    return null
  }

  return (
    <Select
      aria-label="Select a concept"
      className="concepts-container"
      disabled={selectorDisabled}
      id={id}
      onChange={handleSelectorChange}
      options={conceptsToOptions()}
      placeholder="Please select a concept."
      style={{display: 'block'}}
      value={currentValue()}
    />
  )

}

function select (state) {
  return {
    concepts: state.concepts,
    conceptsFeedback: state.conceptsFeedback
  }
}

export default connect(select)(ConceptSelector)
